/** Public reference for the Feathr API, for admins who create a Feathr API key. */
export const FEATHR_API_DOCS_URL = 'https://docs.feathr.co/';

/** Help article for connecting Feathr to other apps with a Zapier key. */
export const ZAPIER_SETUP_ARTICLE_URL =
  'https://help.feathr.co/hc/en-us/articles/7737535248407-How-to-Set-Up-Feathr-Integrations-using-Zapier';
